import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import Contacthero from "./sections/Contacthero";
import ConnectWithAnAgent from "./sections/ConnectWithAnAgent";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <Contacthero />
      <ConnectWithAnAgent />
      <Footer />
    </div>;
}